import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementBrandMenuHour } from '@/pages/menu-managements/business-hours/service';
import { MenuManagementBrandMenuHourService } from '@/services/BrandMenuHour/MenuManagementBrandMenuHourService';
import { MenuManagementListQueryParams } from '@/services/Service/MenuManagementList';

export type MenuManagementBrandMenuListParams = MenuManagementListQueryParams;

export type BrandMenuHourListResponse = {
  brand_menu_hours: MenuManagementBrandMenuHour[];
  count: number;
};

export const useMenuManagementBrandMenuHourList = async (
  params: MenuManagementBrandMenuListParams
): Promise<BrandMenuHourListResponse> => {
  const menuManagementBrandMenuHourService =
    new MenuManagementBrandMenuHourService(getClient());
  try {
    const res = await menuManagementBrandMenuHourService.list(params);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
